import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import { Autoplay, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import { useNotification } from '../Contexts/NotificationContext';

const HomeBanner = () => {
    const { setNotification } = useNotification();
    const [slides, setSlides] = useState([]);

    const accessToken = localStorage.getItem('access_token');
    const baseUrl = process.env.REACT_APP_API_URL;

    useEffect(() => {
        const fetchSlides = async () => {
            try {
                const response = await fetch(`${baseUrl}/painel/slides`, {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                });

                if (response.ok) {
                    const data = await response.json();
                    setSlides(data.slides);
                } else {
                    throw new Error('Erro ao buscar o conteúdo');
                }
            } catch (error) {
                setNotification({
                    type: 'error',
                    message: error.message,
                    show: true,
                });
            }
        };

        fetchSlides();
    }, []);

    return (
        <div className="relative mb-10 z-[1] before:content-[''] before:absolute before:w-screen before:left-1/2 before:-top-4 md:before:-top-10 2xl:before:-top-14 before:-translate-x-1/2 before:h-[90%] before:bg-quaternary before:-z-[1]">
            <div className="overflow-hidden rounded-xl">
                <Swiper
                    key={slides.length}
                    loop={true}
                    slidesPerView={1}
                    slidesPerGroup={1}
                    autoplay={{
                        delay: 8000,
                    }}
                    pagination={{
                        clickable: true,
                    }}
                    modules={[Pagination, Autoplay]}
                    className="[&_.swiper-pagination]:text-left max-sm:[&_.swiper-pagination.swiper-pagination-bullets.swiper-pagination-horizontal]:scale-75 [&_.swiper-pagination.swiper-pagination-bullets.swiper-pagination-horizontal]:origin-bottom-left [&_.swiper-pagination.swiper-pagination-bullets.swiper-pagination-horizontal]:left-[7%] md:[&_.swiper-pagination.swiper-pagination-bullets.swiper-pagination-horizontal]:left-[4%] [&_.swiper-pagination.swiper-pagination-bullets.swiper-pagination-horizontal]:right-14 [&_.swiper-pagination.swiper-pagination-bullets.swiper-pagination-horizontal]:w-auto max-sm:[&_.swiper-pagination.swiper-pagination-bullets.swiper-pagination-horizontal]:bottom-4 [&_.swiper-pagination.swiper-pagination-bullets.swiper-pagination-horizontal]:bottom-8 [&_.swiper-pagination-bullet]:bg-white [&_.swiper-pagination-bullet]:opacity-100 [&_.swiper-pagination-bullet.swiper-pagination-bullet-active]:bg-primary [&_.swiper-pagination-bullet]:w-11 [&_.swiper-pagination-bullet]:h-[3px] [&_.swiper-pagination-bullet]:rounded-none"
                >
                    {slides.map((slide, index) => (
                        <SwiperSlide key={index}>
                            <div>
                                <picture>
                                    <source srcSet={slide.imagem_mobile} media="(max-width: 768px)" />
                                    <img src={slide.imagem} className="w-full" loading="lazy" alt="Slide" />
                                </picture>

                                <div className="absolute left-[7%] md:left-[4%] sm:bottom-16 xl:bottom-[18%] top-[20%] lg:top-[30%] flex flex-col justify-between items-start">
                                    <h2 className="sm:text-lg max-md:leading-tight max-md:tracking-tight md:text-2xl xl:text-[2.4em] xl:!leading-[1em] text-primary font-light whitespace-pre-line mt-2 mb-5">
                                        {slide.chamada}
                                    </h2>

                                    {slide.link && (
                                        <Link
                                            to={slide.link}
                                            className="max-sm:scale-75 origin-bottom-left bg-white text-primary max-lg:text-sm font-bold uppercase px-4 xl:px-8 rounded-lg py-2 transition-all hover:bg-secondary hover:text-white"
                                        >
                                            {slide.botao}
                                        </Link>
                                    )}
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    );
};

export default HomeBanner;
